<div class="container">
  <form novalidate autocomplete="false" name="topbar-search" method="post" action="">
    <input autocomplete="false" name="hidden" type="text" style="display:none;">
    
    <div class="input-loading" *ngIf="state === 'loading'"></div>
    <div class="not-found" *ngIf="state === 'not-found'">
      <i class="material-icons not-found-icon">close</i>
    </div>

    <input 
      #caixaDePesquisa
      *ngIf="caixaDePesquisaVisivel"
      autocomplete="new-password"
      [@panelInOut]
      [(ngModel)]="valor"
      placeholder="ctrl + espaço"
      id="caixaDePesquisa"
      name="password"
      type="text" 
      class="input card"
      (keyup.enter)="onKeyUpEnter()"
      (keyup.arrowdown)="onKeyUpDown()"
      (keyup.arrowup)="onKeyUpUp()"
      (change)="onChangeCaixaDePesquisa()"
      (keyup)="onKeyUpCaixaDePesquisa()"
      (blur)="onBlurCaixaDePesquisa()"
      (focus)="onFocusCaixaDePesquisa()" />

    <a 
      title="Pesquisar pacientes (ctrl + espaço)"
      (click)="toggleCaixaDePesquisa()"
      class="material-icons icon-search"
      [ngClass]="(caixaDePesquisaVisivel ? 'icon-search-on' : '')">search</a>
  </form>
</div>

<div class="container-resultado card" *ngIf="pacientes && pacientes.length > 0">
  <div *ngFor="let paciente of pacientes, let i = index" (click)="abrirPaciente(paciente)">
    <app-topbar-search-item-resultado 
      [paciente]="paciente" 
      [activeIndex]="activeIndex"
      [index]="i+1">
    </app-topbar-search-item-resultado>
  </div>
</div>
